// extracted by mini-css-extract-plugin
module.exports = {"templateCardList":"TemplateCardList_templateCardList__2oQiL","templateCard":"TemplateCardList_templateCard__Kv4Q0"};